module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble",
      "lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XV",
      "role": "doc-pagebreak",
      "title": "XV"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "Image",
      "id": "pre2",
      "src": "images/pre2.jpg"
    }
  })])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_vm._v("THE WORK OF ")]), _vm._v("this book matters because the gospel matters. If we are eager to see the transformation of the world, or even just the transformation of our own lives, we have to come to grips with the fact that the good news of Jesus Christ is the only thing that can do this. Our trying harder, being more clever, or implementing better structures or strategies—none of these things can do it. Only the gospel can. Writing to the first-century church in Galatia, Paul passionately expresses how he longs for their transformation “until Christ is formed in you” (Gal 4:19). The apostle had spent the previous chapters belaboring the fact that the only way Christ can be formed in us is when we abandon the idea that we can do it on our own and instead live every day by saying, “The only way I’m going to be able to do this is by trusting that you’ve already done it for me.” The gospel, all by its naked self, does this formational work.")]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This book is attempting to build a cumulative case for how this vision of the formational power of the naked gospel can be unleashed in the worship services of the people of God. The book will therefore sometimes sound like a broken record when words and phrases like "), _c('i', [_vm._v("grammar")]), _vm._v(", "), _c('i', [_vm._v("faith alone")]), _vm._v(" ("), _c('i', [_vm._v("sola fide")]), _vm._v("), "), _c('i', [_vm._v("justification")]), _vm._v(", and, yes, "), _c('i', [_vm._v("gospel")]), _vm._v(" keep coming up. Stay with it. Along these lines, some readers who wish for the book to take on a more measured and scholarly objectivity may be disappointed by my occasional editorializing, especially in footnotes. For better or worse, nearly twenty years of pastoral ministry biases me toward verbalizing the “so what” a little more often than strict academic scholarship typically does. Therefore, for some this editorializing may be a liability. But for others straining for implication and application, such interjections will be a lifeline. Either way, my hope for this book is that, in its historical-theological inquiry, it might establish "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVI",
      "role": "doc-pagebreak",
      "title": "XVI"
    }
  }, [_vm._v("enough categories for what we now refer to as gospel-centered worship so that people who care about all of this, in their own areas of influence in Christ’s church, might be given more imaginative runways to launch into the same kind of work Cranmer did.")])]), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Lord, we beseche thee to kepe thy Churche and housholde continually in thy true religion; that they whiche do leane onlye upon hope of thy heavenly grace may evermore bee defended by thy mightie power; through Christ our lorde.")])]), _c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Collect for the Fifth Sunday after the Epiphany (Book of Common Prayer, 1552)")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30defbe2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre3.vue
// module id = 72
// module chunks = 0